module.exports = "/_next/static/images/MakeDataDrivenDecisions@2x-7b3d495ab828036c221de19922f35a74.png";